import store from '../store';

export default function resetOidcStore() {
    store.dispatch('cart/updateOwnerToken', null);
    // https://github.com/perarnborg/vuex-oidc/wiki#api
    store.dispatch('oidc/removeOidcUser'); // Signs out user in vuex and browser storage, but not in open id provider
    store.dispatch('oidc/signOutOidcSilent'); // Signs out user in open id provider using a hidden iframe
}
